var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-form',[_c('font-awesome-layers',{staticClass:"fa-2x ml-2",attrs:{"full-width":""}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'question-circle']},on:{"click":_vm.showHelpCrunch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }